var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDbotIcon = function SvgDbotIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#FF6444",
    fillRule: "nonzero",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.72 13.26a.845.845 0 1 0 0-1.69.845.845 0 0 0 0 1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M25.26 15.43v-4.6A4.84 4.84 0 0 0 20.43 6h-3.86v9.43h8.69zM16.57 26h3.86a4.84 4.84 0 0 0 4.83-4.83v-4.6h-8.69V26zm-4.775-12.1a2.825 2.825 0 1 1 2.77-3.36h.865V6h-3.86a4.84 4.84 0 0 0-4.83 4.83v10.34A4.84 4.84 0 0 0 11.57 26h3.86V11.605h-.865a2.825 2.825 0 0 1-2.77 2.295z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }))));
};

export { SvgDbotIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9IiNGRjY0NDQiIGZpbGwtcnVsZT0ibm9uemVybyIgcng9IjYiLz48cGF0aCBkPSJNMTMuNzIgMTMuMjZhLjg0NS44NDUgMCAxMDAtMS42OS44NDUuODQ1IDAgMDAwIDEuNjl6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMjUuMjYgMTUuNDN2LTQuNkE0Ljg0IDQuODQgMCAwMDIwLjQzIDZoLTMuODZ2OS40M2g4LjY5ek0xNi41NyAyNmgzLjg2YTQuODQgNC44NCAwIDAwNC44My00Ljgzdi00LjZoLTguNjlWMjZ6bS00Ljc3NS0xMi4xYTIuODI1IDIuODI1IDAgMTEyLjc3LTMuMzZoLjg2NVY2aC0zLjg2YTQuODQgNC44NCAwIDAwLTQuODMgNC44M3YxMC4zNEE0Ljg0IDQuODQgMCAwMDExLjU3IDI2aDMuODZWMTEuNjA1aC0uODY1YTIuODI1IDIuODI1IDAgMDEtMi43NyAyLjI5NXoiLz48cGF0aCBkPSJNMCAwaDMydjMySDB6Ii8+PC9nPjwvc3ZnPg==";